module.exports = __webpack_public_path__ + "img/SER-B-1-III.b7c03d51.png";